import Axios from 'axios'
import { secureSS, makeRsa } from '@/assets/js/common.js'

const axios = Axios.create()
const kinxAxios = Axios.create()

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL


let axiosRequest = false
let aFunc = null

axios.interceptors.request.use(
  async function (config) {
    if (!axiosRequest && sessionStorage.getItem('accessToken')) {
      axiosRequest = true
      let res = await window.TokenService._watchToken()
      if (res) {
        return window.location.replace('/demo')
      }

      aFunc = setTimeout(() => {
        axiosRequest = false
      }, 1000)
    }
    return config
  }
)


// 번역서버
const transAxios = Axios.create()
transAxios.defaults.baseURL = 'https://ntrans.fantoo.co.kr'

function translation (obj) {
  return transAxios({
    method: 'post',
    url: `/trans`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(obj)
  })
}



// 판매사이트 - 문의하기
function requestOrder(info) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(info))

  return axios({
    method: 'post',
    url: `operations/consulting`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: formdata
  })
}


// 데모계정 로그인
function demoLogin() {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({demoType: 1}))

  return axios({
    method: 'post',
    url: `auth/demologin`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: formdata
  })
}





/**
 * 메인
 */
// 상품정보
function getProductList(param = '') {
  return axios.get(`products/lists${'?' + param}`)
}
// 상품리스트
function getProductLists(getInfo) {
  return axios({
    method: 'get',
    url: `products/mainlist?`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params : getInfo
  })
}

// 메인 기획전 리스트 조회
function getBindingProducts(prdtSysId, getInfo) {
  return axios({
    method: 'get',
    url: `products/${prdtSysId}/bundleshipping/list?${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 판매자 고시정보 조회
function getSellerOpenInfo(sellerSysId, brandSysId) {
  return axios.get(`sellers/${sellerSysId}/notice?brandSysId=${brandSysId}`)
}

// 메인 기획전 리스트 조회
function getPlanningList(getInfo) {
  return axios({
    method: 'get',
    url: `operations/plans/mainlist${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 메인 배너 기획전 리스트 조회
function getMainBannerList(param) {
  return axios({
    method: 'get',
    url: `operations/bannerplans/main/lists`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: param
  })
}

// 메인 배너 기획전 조회
function getMainBannerPlan(bannerPlanSysId) {
  return axios({
    method: 'get',
    url: `operations/bannerplans/${bannerPlanSysId}/main`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 메인 배너 기획전 상품 리스트 조회
function getMainBannerPlanList(getInfo) {
  return axios({
    method: 'get',
    url: `operations/bannerplans/${getInfo.bannerPlanSysId}/prdts/lists?startIndex=${getInfo.startIndex}&rowCount=${getInfo.rowCount}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 메인 배너 단건 조회
function getSingleBannerPlan(planSysId) {
  return axios({
    method: 'get',
    url: `/operations/bannerplan/${planSysId}`
  })
}

// 이벤트기획전 조회
function getEventPlan(eventPlanSysId) {
  return axios({
    method: 'get',
    url: `operations/eventplans/${eventPlanSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 주문정보조회
function getOrderInfo(accessToken, orderSysId) {
  return axios({
    method: 'get',
    url: `orders/${orderSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 회원 주문상품 취소내역조회
function getCancelOrders(accessToken, params) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/cancelOrders`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    params
  })
}

// 회원 주문상품 반품내역조회
function getReturnOrders(accessToken, params) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/returnOrders`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    params
  })
}

// 회원 주문상품 교환내역조회
function getExchangeOrders(accessToken, params) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/exchangeOrders`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    params
  })
}

// 주문상품 교환 정보 수정
function patchExchangeDeliveryInfo(accessToken, { orderSysId, orderPrdtSysId, orderExProductSysId }, params) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(params))
  return axios({
    method: 'patch',
    url: `orders/${orderSysId}/products/${orderPrdtSysId}/exchange/${orderExProductSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}
// 주문상품 반품 정보 수정
function patchReturnDeliveryInfo(accessToken, { orderSysId, orderPrdtSysId, orderReturnPrdtSysId }, params) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(params))
  return axios({
    method: 'patch',
    url: `orders/${orderSysId}/products/${orderPrdtSysId}/return/${orderReturnPrdtSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}



// 주문상품리스트정보조회
function getOrderPrdtList(accessToken, orderSysId) {
  return axios({
    method: 'get',
    url: `orders/${orderSysId}/products`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 주문상품정보조회
function getOrderPrdtInfo(accessToken, orderSysId, orderPrdtSysId) {
  return axios({
    method: 'get',
    url: `orders/${orderSysId}/products/${orderPrdtSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 주문상품취소신청
function setOrderCancle(accessToken, setInfo, orderSysId, orderPrdtSysId) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(setInfo))
  return axios({
    method: 'post',
    url: `orders/${orderSysId}/products/${orderPrdtSysId}/proposaling/cancel`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 주문취소처리
function deleteOrder(accessToken, orderSysId, params) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(params))
  return axios({
    method: 'delete',
    url: `orders/${orderSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 주문상품교환신청
function setOrderExchange(accessToken, { orderSysId, orderPrdtSysId }, { info, files }) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(info))
  files.forEach((file, idx) => {
    formdata.append(`prdtImgFile${idx + 1}`, file)
  })
  return axios({
    method: 'post',
    url: `orders/${orderSysId}/products/${orderPrdtSysId}/proposaling/exchange`,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 주문상품반품신청
function setOrderReturn(accessToken, { orderSysId, orderPrdtSysId }, { info, files }) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(info))
  files.forEach((file, idx) => {
    formdata.append(`prdtImgFile${idx + 1}`, file)
  })
  return axios({
    method: 'post',
    url: `orders/${orderSysId}/products/${orderPrdtSysId}/proposaling/return`,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 주문상품 교환,반품 배송비 요청
function getReqDeliveryPay(accessToken, { orderSysId, orderPrdtSysId }, params) {
  return axios({
    method: 'get',
    url: `orders/${orderSysId}/products/${orderPrdtSysId}/deliverypay`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    params
  })
}

// 주문상품 교환,반품 배송비 등록
function postReqDeliveryPay(accessToken, { orderSysId, orderPrdtSysId }, params) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(params))

  return axios({
    method: 'post',
    url: `orders/${orderSysId}/products/${orderPrdtSysId}/pays/deliveries`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 교환,반품 배송비 결제 정보 조회
function getReqDeliveryPayInfo(accessToken, deliveryPaySysId) {
  return axios({
    method: 'get',
    url: `deliveries/pays/${deliveryPaySysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
  })
}




// 배송회사 리스트 조회
function getDeliveryCompanyList() {
  return axios({
    method: 'get',
    url: `preferences/deliveryCompanys`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}



// 배송회사정보조회
function getDeliveryCompany(deliveryCompSysId) {
  return axios({
    method: 'get',
    url: `preferences/deliveryCompanys/${deliveryCompSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 비회원 주문정보 조회
function getNonUserOrderInfo(jsonData) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(jsonData))
  return axios({
    method: 'get',
    url: `orders/nonUser/product`,
    params: jsonData
  })
}
// 카테고리
function getCategoryList(cat) {
  let uri = ''
  if (cat) {
    uri = `?categoryLevel=2&parentSysId=${cat}`
  } else {
    uri = '?categoryLevel=1'
  }
  return axios.get(`categories${uri}`)
}

// 상품세일
function getSaleProduct() {
  return axios.get(`products/salelists`)
}

// 주간베스트상품(Weekly)
function getWeeklyProduct() {
  return axios.get(`products/weeklylists`)
}

// 베스트브랜드
function getBrandList() {
  return axios.get(`brands`)
}

// 브랜드 정보 조회
function getBrandInfo(brandSysId) {
  return axios.get(`brands/${brandSysId}`)
}

// 라이브방송정보 리스트
function getLiveProductList(params) {
  const token = sessionStorage.getItem('accessToken')
  let opt = {
    method: 'get',
    url: `broadcasts/mainlists`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: params
  }
  if (token) { opt.headers.Authorization = `Bearer ${token}` }
  
  return axios(opt)
}

/**
 * 라이브 방송정보
 */
function getLiveProduct(broadcastSysId) {
  return axios.get(`broadcasts/${broadcastSysId}/medialists`)
}

// 방송 라이브 상태 체크
function getLiveStatus(broadcastSysId) {
  return axios({
    method: 'get',
    url: `broadcasts/${broadcastSysId}/chklive`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
}



/*
주문
*/

// 주문정보등록
function postOrders(accessToken, jsonData) {
  if (accessToken) {
    let formdata = new FormData()
    let userSysId = parseJwt(accessToken).authSysId
    jsonData = { ...jsonData, userSysId }

    formdata.append('jsonData', JSON.stringify(jsonData))

    return axios({
      method: 'post',
      url: `orders`,
      data: formdata,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${accessToken}`
      }
    })
  } else {
    let formdata = new FormData()
    jsonData = { ...jsonData }

    formdata.append('jsonData', JSON.stringify(jsonData))

    return axios({
      method: 'post',
      url: `orders`,
      data: formdata,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }
}

// 주문배송비 조회 (브랜드별 묶음배송비)
function getDeliveryPrice(jsonData, accessToken) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(jsonData))
  if (accessToken) {
    return axios({
      method: 'post',
      url: `orders/deliveries`,
      data: formdata,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${accessToken}`
      }
    })
  } else {
    return axios({
      method: 'post',
      url: `orders/deliveries`,
      data: formdata,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }
}

// 주문결제처리 결과통보
function patchOrderResult(orderSysId, jsonData, accessToken) {
  if (accessToken) {
    let formdata = new FormData()
    formdata.append('jsonData', JSON.stringify(jsonData))

    return axios({
      method: 'patch',
      url: `orders/pays/${orderSysId}/notifies`,
      data: formdata,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${accessToken}`
      }
    })
  } else {
    let formdata = new FormData()
    formdata.append('jsonData', JSON.stringify(jsonData))

    return axios({
      method: 'patch',
      url: `orders/pays/${orderSysId}/notifies`,
      data: formdata,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }
}

// 주문결제정보 등록
function payOrders(jsonData, orderSysId, accessToken) {
  if (accessToken) {
    let formdata = new FormData()
    formdata.append('jsonData', JSON.stringify(jsonData))

    return axios({
      method: 'post',
      url: `orders/${orderSysId}/pays`,
      data: formdata,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${accessToken}`
      }
    })
  } else {
    let formdata = new FormData()
    formdata.append('jsonData', JSON.stringify(jsonData))

    return axios({
      method: 'post',
      url: `orders/${orderSysId}/pays`,
      data: formdata,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }
}

// 주문결제정보조회
function getPayOrder(accessToken, orderSysId) {
  return axios.get(`orders/pays/${orderSysId}`, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 내 정보 조회
function getMypageInfo(accessToken) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios.get(`users/${userSysId}/mypage`, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 회원 정보 가져오기
function getUserInfo(accessToken) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 회원주문정보조회
function getUserOrders(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios.get(`users/${userSysId}/orders?${getInfo}`, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 내정보 관리 변경
function modifyUserInfo(accessToken, userInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(userInfo))
  return axios({
    method: 'patch',
    url: `users/${userSysId}/myinfo`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 내정보 관리 변경
function uploadImage(accessToken, imgInfo) {
  return axios({
    method: 'post',
    url: `cdzn/images`,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${accessToken}`
    },
    data: imgInfo
  })
}


// 킨스 영상 업로드
async function uploadMovie(accessToken, mov) {
  try {
    let res = await getKinxMidBusToken(accessToken)
    let auth = res.data.jsonData.resultCode === "0001" ? res.data.jsonData.token : null

    let formData = new FormData();
    formData.append("file", mov);


    return kinxAxios.request({
      method: "post",
      url: "https://api.midibus.kinxcdn.com/v1/upload/1098/productReview",
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Mbus-Token": auth
      },
      data: formData,
    })
  } catch (err) {
    console.error('영상 업로드 에러', err);
  }
}





// 회원 주소 목록 가져오기
function getMemberAddrList(accessToken) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios.get(`users/${userSysId}/listaddress`, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 회원 주소 등록
function addMemberAddress(accessToken, addrInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(addrInfo))
  return axios({
    method: 'post',
    url: `users/${userSysId}/address`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 회원 주소 삭제
function deleteMemberAddress(accessToken, addrSysId) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(addrSysId))
  return axios({
    method: 'delete',
    url: `users/${userSysId}/address`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 추가 배송비 조회
function getAddingCosts(postNumber, prdtSysIds) {
  return axios.get(`operations/deliveries/addingCosts`, {
    params: {
      postNumber,
      prdtSysIds
    }
  })
}

// 회원 포인트 수정
function patchUserPoint(accessToken, pointData) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(pointData))
  return axios({
    method: 'patch',
    url: `users/${userSysId}/points`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 회원주문상품신청(취소/교환/반품)내역조회
function getCancleExchangeList(accessToken, params) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/orders/requests`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    params
  })
}

// 은행정보조회
function getBanks() {
  return axios.get(`/preferences/banks`, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 이벤트기획전 유효성 체크
function chkEventInvalid(accessToken, postData) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(postData))
  return axios({
    method: 'post',
    url: `operations/eventplans/chkvalid`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 그룹회원체크
function groupChk(accessToken, groupId) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/chkgroup?groupId=${groupId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

/*
 * 검색
 */

// 상품 검색
function searchProducts(keyword, startIndex, rowCount) {
  let userSysId = ''
  if (sessionStorage.getItem('accessToken')) {
    userSysId = '&userSysId=' + parseJwt(sessionStorage.getItem('accessToken')).authSysId
  }
  return axios.get(`products/searchlists?keyword=${encodeURIComponent(keyword)}${userSysId}&startIndex=${startIndex}&rowCount=${rowCount}`)
}
// 브랜드 검색
function searchBrands(keyword) {
  return axios.get(`brands/searchlists?keyword=${encodeURIComponent(keyword)}`)
}
// 방송 검색
function searchBroadcasts(keyword) {
  return axios.get(`broadcasts/searchlists?keyword=${encodeURIComponent(keyword)}`)
}

/**
 *
 * 상품 상세
 */
// 상품 상세 조회
function getProductDetail(prdtSysId, accessToken) {
  let userSysId = ''
  let info = ''

  if (accessToken) {
    userSysId = parseJwt(accessToken).authSysId
    info = '?userSysId=' + userSysId
  }
  return axios.get(`products/${prdtSysId}/detail${info}`)
}

// 단일 상품 조회
function getProduct(prdtSysId) {
  return axios.get(`products/${prdtSysId}`)
}

// 방송 가져오기
function getBroadCast(prdtSysId) {
  return axios.get(`broadcasts/${prdtSysId}`)
}

// 리뷰 목록 가져오기
function getPrdtReviewList(prdtSysId, getInfo) {
  if (!getInfo) {
    getInfo = 'startIndex=0'
  }
  return axios.get(`products/${prdtSysId}/reviews/list?${getInfo}`)
}

// 리뷰 신고하기
function claimReview(accessToken, prdtSysId, prdtReviewSysId, data) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(data))

  return axios({
    method: 'post',
    url: `products/${prdtSysId}/reviews/${prdtReviewSysId}/claims`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 문의 목록 가져오기
function getPrdtQuestionList(prdtSysId, getInfo) {
  return axios.get(`products/${prdtSysId}/questions/list?${getInfo}`)
}

// 문의 등록하기
function postPrdtQuestion(accessToken, prdtSysId, qaData) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(qaData))

  return axios({
    method: 'post',
    url: `products/${prdtSysId}/questions`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 회원 문의 답변 확인(읽음)
function reqSetRead(accessToken, setInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(setInfo))
  return axios({
    method: 'patch',
    url: `users/${userSysId}/questions/${setInfo.questionSysId}/read`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

/*
 * 장바구니
 */

// 회원 장바구니 등록
function postCartItem(accessToken, cartItem) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(cartItem))
  return axios({
    method: 'post',
    url: `users/${userSysId}/baskets`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 회원 장바구니 가져오기
function getCartItem(accessToken) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/baskets/list`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 회원 장바구니 삭제
function removeCartItem(accessToken, basketSysId) {
  let userSysId = parseJwt(accessToken).authSysId

  return axios({
    method: 'delete',
    url: `users/${userSysId}/baskets/${basketSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 장바구니 목록 삭제
function removeCartList(accessToken, basketSysIds) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(basketSysIds))

  return axios({
    method: 'delete',
    url: `users/${userSysId}/baskets/list`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 장바구니 수정
function putCartItem(accessToken, basketSysId, cartItem) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(cartItem))
  return axios({
    method: 'put',
    url: `users/${userSysId}/baskets/${basketSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 비회원 장바구니 회원장바구니로 합치기
async function nonMemberCartMerge() {
  if (sessionStorage.getItem('nonMemberCartList')) {
    let nCart = secureSS.get('nonMemberCartList')
    for (const c of nCart) {
      let cartItem = {
        prdtSysId: c.prdtSysId,
        basketQty: c.basketQty,
        isOption: c.isOption,
        optionTypeCode: c.optionTypeCode,
        isAddingProduct: c.isAddingProduct,
        broadcastScheduleSysId : c.broadcastScheduleSysId,
        // optionGroups:,
        // addingProducts
      }

      if (!cartItem.broadcastScheduleSysId) { 
        delete cartItem.broadcastScheduleSysId
      }

      if (c.optionGroups) {
        cartItem.optionGroups = []
        for (const o of c.optionGroups) {
          let groupItem = {
            optionQty: o.optionQty,
            productOptions: []
          }

          for (const po of o.productOptions) {
            groupItem.productOptions.push({
              prdtOptionSysId: po.prdtOptionSysId,
              optionKeyName: po.optionKeyName
            })
          }

          cartItem.optionGroups.push(groupItem)
        }
      }

      if (c.isAddingProduct) {
        cartItem.addingProducts = []
        for (const ap of c.addingProducts) {
          cartItem.addingProducts.push({
            prdtAddingProductSysId: ap.prdtAddingProductSysId,
            prdtAddingProductDetailSysId: ap.prdtAddingProductDetailSysId,
            addingQty: ap.addingQty
          })
        }
      }

      
      try {
        let res = await postCartItem(sessionStorage.getItem('accessToken'), cartItem)
        // console.log(res);
      } catch (err) {
        console.error(err);
      }
    }
    sessionStorage.removeItem('nonMemberCartList')
  }
}

/**
 *
 * 내 정보
 */
// 1:1 문의 등록
function writeQuestion(accessToken, questionInfo) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(questionInfo))
  return axios({
    method: 'post',
    url: `operations/questions`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 내 정보-공지사항 조회(조건)
function getNoticeList(sIdx, rCnt) {
  let req = { startIndex: sIdx, rowCount: rCnt }
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(req))
  return axios({
    method: 'get',
    url: `operations/notices/list?startIndex=${sIdx}&rowCount=${rCnt}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 내 정보-패스워드 변경
function changePw(accessToken, pwInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(pwInfo))
  return axios({
    method: 'patch',
    url: `users/${userSysId}/password`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 내 정보-최근 본 상품 등록
function setRecentViewList(accessToken, viewInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(viewInfo))
  return axios({
    method: 'post',
    url: `users/${userSysId}/prdtviews`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 내 정보-최근 본 상품 조회
function getRecentViewList(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/prdtviews/list${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 마이 리뷰 목록 가져오기
function getMyReviewList(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/reviews/list${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 리뷰 작성
function postReview(accessToken, prdtSysId, reviewInfo) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(reviewInfo))
  return axios({
    method: 'post',
    url: `products/${prdtSysId}/reviews`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 리뷰 수정
function putReview(accessToken, prdtSysId, prdtReviewSysId, modifyReviewInfo) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(modifyReviewInfo))
  return axios({
    method: 'put',
    url: `products/${prdtSysId}/reviews/${prdtReviewSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

//리뷰 삭제 

function deleteReview(accessToken, prdtSysId, prdtReviewSysId) {
  return axios({
    method: 'patch',
    url: `products/${prdtSysId}/reviews/${prdtReviewSysId}/deleted`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 내 정보-최근 본 상품 삭제(리스트)
function delRecentViewList(accessToken, lists) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(lists))
  return axios({
    method: 'delete',
    url: `users/${userSysId}/prdtviews/list`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 내 정보-찜한 상품 등록
function setPicksList(accessToken, pickInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(pickInfo))
  return axios({
    method: 'post',
    url: `users/${userSysId}/prdtpick`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 내 정보-찜한 상품 삭제
function delPicksList(accessToken, prdtPickSysId) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'delete',
    url: `users/${userSysId}/prdtpick/${prdtPickSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 내 정보-찜한 상품 조회
function getPicksList(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/prdtpick/list${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 내 정보-찜한 상품 삭제(리스트)
function delPicksLists(accessToken, lists) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(lists))
  return axios({
    method: 'delete',
    url: `users/${userSysId}/prdtpick/list`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 내 정보-마이 포인트 내역 조회
// flag - 0: 전체 1: 적립 2:사용.
function getPointInfo(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/pointhists/list${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 내 정보-알림 설정 조회
function getAlertSetting(accessToken) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/push/info`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}
// 내 정보-알림 설정 수정
function setAlertSetting(accessToken, setInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(setInfo))
  return axios({
    method: 'patch',
    url: `users/${userSysId}/push/info`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 상품 리뷰 가져오기
function getProductReview(prdtSysId, prdtReviewSysId) {
  return axios({
    method: 'get',
    url: `products/${prdtSysId}/reviews/${prdtReviewSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 내 정보 - 팔로잉 목록 조회
function getFollowing(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/follows/list${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 내 정보 - 상품문의 - 주문정보조회
function getOrderedList(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/orders/products/list${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 회원 구매내역 조회
function getOrdersList(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/orders/list${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 내 정보 - 상품문의 - 문의 등록
function sendOrderRequest(accessToken, setInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(setInfo))
  return axios({
    method: 'post',
    url: `users/${userSysId}/orders/${setInfo.orderSysId}/products/${setInfo.orderPrdtSysId}/questions`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 내 정보 - 나의문의내역 조회
function getMyQeustion(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/questions/list${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 내 정보 - 배송 조회
function getDeliveryLog(accessToken, orderSysId, orderPrdtSysId) {
  return axios({
    method: 'get',
    url: `orders/${orderSysId}/products/${orderPrdtSysId}/deliveries`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 내 정보 - 회원주문구매확정
function setBuyFinish(accessToken, orderPrdtSysId) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({ userSysId: userSysId, orderPrdtSysId: orderPrdtSysId }))
  return axios({
    method: 'patch',
    url: `users/${userSysId}/orders/${orderPrdtSysId}/completedPurcharse`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

/**
 *
 * 고객센터
 */

// 고객센터 - FAQ 목록 조회
function getFaqList(getInfo) {
  return axios({
    method: 'get',
    url: `operations/faqs${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}


/**
 *
 * 편성표
 */
// 편성표 목록 가져오기
function getBroadCastSchedules(startDate, accessToken) {
  let urlStr = `broadcasts/schedules/list?startIndex=0&rowCount=50&startDate=${startDate}`
  if (accessToken) {
    let userSysId = parseJwt(accessToken).authSysId
    urlStr += `&userSysId=${userSysId}`
  }
  return axios({
    method: 'get',
    url: urlStr,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// ----------------------  old
// 방송예약 등록
function setReservateBroadCast(accessToken, broadcastScheduleSysId) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({ 'broadcastScheduleSysId': broadcastScheduleSysId }))
  return axios({
    method: 'post',
    url: `users/${userSysId}/broadcastreservations`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}
// 방송예약 조회
function getReservateBroadCast(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/broadcastreservations/list${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}
// 방송예약 취소
function removeReservateBroadCast(accessToken, userBroadcastReservationSysId) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'delete',
    url: `users/${userSysId}/broadcastreservations/${userBroadcastReservationSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 방송 예고 정보 조회
function getLiveIntroInfo(broadcastSysId, broadcastScheduleSysId) {
  return axios({
    method: 'get',
    url: `broadcasts/${broadcastSysId}/intro`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: {
      broadcastScheduleSysId
    }
  })
}

// 신규
// 방송 푸시알림 예약
function broadcastReservation (param) {
  const token = sessionStorage.getItem('accessToken')
  let userSysId = parseJwt(token).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({ 'isAlarm': param.isAlarm }))

  return axios({
    method: 'post',
    url: `/users/${userSysId}/alarms/broadcasts/${param.broadcastSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${token}`
    },
    data: formdata
  })
}

function broadcastReserveList (param) {
  const token = sessionStorage.getItem('accessToken')
  let userSysId = parseJwt(token).authSysId

  return axios({
    method: 'get',
    url: `users/${userSysId}/alarms/broadcasts/histories`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${token}`
    },
    params: param
  })
}

/**
 *
 * KINX 토큰
 */

function getKinxToken(accessToken) {
  return axios({
    method: 'get',
    url: `kinx/cdn/token`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

function getKinxMidBusToken(accessToken) {
  return axios({
    method: 'get',
    url: `kinx/midbus/token`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

/**
 *
 * 회원가입
 */

// 공개키 조회
function getPublicKey() {
  return axios.get(`auth/publickey`)
}

// RSA암호화 확인
function checkRSA(rsaEncStr) {
  const jsonData = {
    'rsaEncStr': rsaEncStr
  }
  var formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(jsonData))
  return axios.post(`auth/chkrsa`, formdata)
}

// 아이디 중복확인
function checkJoinId(id) {
  const jsonData = {
    'userId': id
  }
  return axios.get(`users/chkdupid`, {
    params: jsonData
  })
}

// 닉네임 중복확인
function checkJoinNick(nick) {
  return axios.get(`users/chkdupnick?nickName=${nick}`)
}

// 본인인증전송
function sendSms(authType, authWay, authWayValue, userId) {
  let jsonData = {
    'authType': authType,
    'authWay': authWay,
    'authWayValue': authWayValue,
    'userId': userId
  }
  var formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(jsonData))
  return axios.post(`auth/sendauthmine`, formdata)
}

// 본인인증확인
function chkSmsAuth(authType, authWay, authWayValue, authNo, userId) {
  let jsonData = {
    'authType': authType,
    'authWay': authWay,
    'authWayValue': authWayValue,
    'authNo': authNo,
    'userId': userId
  }
  var formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(jsonData))
  return axios.post(`auth/chkauthmine`, formdata)
}

// 본인인증결과
// function retauthMine (authType, authWay, authWayValue, userId) {
//   let jsonData = {
//     'authType': authType,
//     'authWay': authWay,
//     'authWayValue': authWayValue,
//     'userId': userId
//   }
//   var formdata = new FormData()
//   formdata.append('jsonData', JSON.stringify(jsonData))
//   return axios.post(`auth/retauthmine`, formdata)
// }

// 패스워드 찾기
function searchPassword(accessToken, password) {
  let jsonData = {
    'password': password
  }
  var formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(jsonData))
  return axios({
    method: 'patch',
    url: `users/password`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
  // return axios.patch(`users/password`, formdata, {
  //   'Content-Type': 'application/x-www-form-urlencoded',
  //   'Authorization': `Bearer ${authToken}`
  // })
}

// 회원가입
function createtUser(user) {
  let jsonData = {
    'userId': user.userId,
    'password': user.password,
    'nickName': user.nickName,
    'agreeSellection1': user.agreeSellection1,
    'agreeSellection2': user.agreeSellection2,
    'isAppInstall': user.isAppInstall
  }
  if (user.mobile) { jsonData.mobile = user.mobile }
  
  if (sessionStorage.getItem('joinAddInfo')) {
    let joinAddInfo = JSON.parse(sessionStorage.getItem('joinAddInfo'))
    jsonData.rcmdUserSysId = parseInt(joinAddInfo.userSysId)
    jsonData.rcmdLinkCreatedAt = joinAddInfo.date
  }
  console.log('회원가입 data : ', jsonData)
  var formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(jsonData))
  return axios.post(`auth/join`, formdata)
}

// rsa키 요청
function chkRsaKey () {
  return axios({
    method: 'get',
    url: `auth/publickey`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 일반로그인
async function userLogin(userId, password, isRsa) {
  let pas = password
  if (!isRsa) { pas = await makeRsa(password) }

  let jsonData = {
    'userId': userId,
    'password': pas
  }
  var formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(jsonData))
  return axios.post(`auth/login`, formdata)

}

// 간편로그인
function snsLogin(snsType, snsToken, userID) {
  let jsonData = {
    'snsType': snsType,
    'snsToken': snsToken
  }
  if (snsType === 4) {
    jsonData['facebookUserId'] = userID
  }
  if (sessionStorage.getItem('joinAddInfo')) {
    let joinAddInfo = JSON.parse(sessionStorage.getItem('joinAddInfo'))
    jsonData.rcmdUserSysId = parseInt(joinAddInfo.userSysId)
    jsonData.rcmdLinkCreatedAt = joinAddInfo.date
  }
  var formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(jsonData))
  return axios.post(`auth/snslogin`, formdata)
}

// SNS 회원 추가정보
function snsAddInfo(accessToken, addInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  var formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(addInfo))
  return axios({
    method: 'patch',
    url: `users/${userSysId}/addinfo`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 회원 탈퇴
function memberDrop(accessToken) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'patch',
    url: `users/${userSysId}/drop`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// JWT 토큰 파싱 함수
function parseJwt(token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
  return JSON.parse(jsonPayload)
}

// access토큰 발급
function getAccessToken(refreshToken) {
  var formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({ refreshToken: refreshToken }))
  return axios({
    method: 'post',
    url: `auth/accesstoken`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${refreshToken}`
    },
    data: formdata
  })
}

// refresh토큰 갱신
function getRefressToken(refreshToken) {
  var formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({ refreshToken: refreshToken }))
  return axios({
    method: 'post',
    url: `auth/refresh`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${refreshToken}`
    },
    data: formdata
  })
}

/*
 쿠폰
*/

// 쿠폰 발급 가능 리스트 조회
function getAvailableCouponList() {
  return axios({
    method: 'get',
    url: `coupons`
  })
}

// 상품 관계 발급가능 쿠폰 리스트 조회
function getCouponListByPrdt(prdtSysId, sellerSysId, brandSysId) {
  return axios({
    method: 'get',
    url: `coupons/policy/products?prdtSysId=${prdtSysId}&sellerSysId=${sellerSysId}&brandSysId=${brandSysId}`
  })
}

// 쿠폰발급
function getCoupon(accessToken, couponPolicySysId) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({
    couponPolicySysId,
    userSysId
  }))
  return axios({
    method: 'post',
    url: `coupons/${couponPolicySysId}`,
    data: formdata,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 보유 쿠폰 목록
function getHasCouponList(accessToken, searchTypeCode, useTypeCode) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `/coupons/users/${userSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    params: {
      searchTypeCode,
      useTypeCode
    }
  })
}

// 사용 가능 쿠폰 리스트 조회
function getAvailCouponList(accessToken, prdtSysIds) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `/coupons/${userSysId}/products`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    params: {prdtSysIds}
  })
}



// 마이포인트 출금내역
function getRewardWithdrawList(accessToken, startIndex, rowCount, withdrawalApplyStatus) {
  let userSysId = parseJwt(accessToken).authSysId
  if (withdrawalApplyStatus !== 6) {
    return axios({
      method: 'get',
      url: `users/${userSysId}/reviewmoney/withdrawalapply/list?startIndex=${startIndex}&rowCount=${rowCount}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${accessToken}`
      }
    })
  } else {
    return axios({
      method: 'get',
      url: `users/${userSysId}/reviewmoney/withdrawalapply/list?startIndex=${startIndex}&rowCount=${rowCount}&withdrawalApplyStatus=${withdrawalApplyStatus}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${accessToken}`
      }
    })
  }
}

// 회원 포인트 전체조회 (리뷰수익금,포인트 : 사용,적립,출금)

function getAllPointList(accessToken) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/userpoint/list`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 회원 포인트 상태별조회 (포인트 : 사용,적립)
function getPointStatusList(accessToken, startIndex, rowCount, pointstatus) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    // url: `users/${userSysId}/userpoint/pointstatus/${pointstatus}/list?startIndex=${startIndex}&rowCount=${rowCount}`,
    url: `users/${userSysId}/userpoint/status/${pointstatus}/list?startIndex=${startIndex}&rowCount=${rowCount}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}


// 회원 판매리뷰 조회
function getMyRewardList(accessToken, startIndex, rowCount, reqDate) {
  let userSysId = parseJwt(accessToken).authSysId
  if (reqDate === '') {
    return axios({
      method: 'get',
      url: `users/${userSysId}/reviews/rewardlist?startIndex=${startIndex}&rowCount=${rowCount}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${accessToken}`
      }
    })
  } else {
    return axios({
      method: 'get',
      url: `users/${userSysId}/reviews/rewardlist?startIndex=${startIndex}&rowCount=${rowCount}&reqDate=${reqDate}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${accessToken}`
      }
    })
  }
}


//방송화면정보조회
function getBroadCastVodPlay(accessToken, broadcastSysId,broadcastScheduleSysId) {
  return axios({
    method: 'get',
    url: `broadcasts/${broadcastSysId}/cliinfo?broadcastScheduleSysId=${broadcastScheduleSysId}`,
    headers:{
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

//회원이름 금칙어 유효성 체크
function getUserNameforChk(accessToken, name) {
  return axios({
    method: 'get',
    url: `users/chkname?name=${name}`,
    headers:{
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 방송 화면 상품 목록 조회
function getBroadCastPrdts(broadcastSysId,startIndex,rowCount) {
  let urls
  if (startIndex, rowCount) {
    urls = `broadcasts/${broadcastSysId}/products/list?startIndex=${startIndex}&rowCount=${rowCount}`
  } else {
    urls = `broadcasts/${broadcastSysId}/products/list`
  }
  return axios({
    method: 'get',
    url: urls,
    headers:{
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}




// 로그
function sendLog(log) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({ 'log': log }))
  return axios({
    method: 'post',
    url: `analytics/consolelog`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: formdata
  })
}

// 알림톡 대응
function alimTokChk (obj) {
  return axios({
    method: 'get',
    url: `orders/search/${obj.searchType}?value=${obj.qs.value}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 다이나믹링크를 숏링크로 변경
function getShortLinkFromDynamicLink(link) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({ longDynamicLink: link }))
  return axios({
    method: 'post',
    url: `firebase/shortlink`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: formdata
  })
}

// 다시보기 회원접속누적 수 증가
function increaseViewCnt(broadcastSysId) {
  return axios({
    method: 'patch',
    url: `broadcasts/replay/${broadcastSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}


//모바일 라이브방송 목록 조회
function getSellerBroadCastList(accessToken,startIndex,rowCount,type,sysId) {
  return axios({
    method: 'get',
    url: `broadcasts/scheduletype/list?startIndex=${startIndex}&rowCount=${rowCount}&scheduleType=${type}&sallySysId=${sysId}`,
    headers:{
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

//판매자  목록 조회
function getSellerContractList (accessToken,startIndex,rowCount,sysId) {
// let formdata = new FormData()
// formdata.append('jsonData', JSON.stringify(keyword))
  return axios({
    method: 'get',
    url: `sally/preregistration/list?startIndex=${startIndex}&rowCount=${rowCount}&sallySysId=${sysId}`,
    headers:{
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    // data: formdata
  })
}

// 판매자  사전등록
function postSellerPreRegist (accessToken, jsonData) {
let formdata = new FormData()
formdata.append('jsonData', JSON.stringify(jsonData))
  return axios({
    method: 'put',
    url: `sally/preregistration`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 모바일 라이브방송 상세조회
function getLiveStreamDetail(accessToken, broadcastScheduleSysId) {
  return axios({
    method: 'get',
    url: `/broadcasts/scheduletype/${broadcastScheduleSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 셀러 판매현황 상세 조회
function getSellerSellHistory (accessToken, broadcastSysId) {
  return axios({
    method: 'get',
    url: `/broadcasts/${broadcastSysId}/products`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 일반회원 셀러회원 조회
function userCheckSeller (accessToken) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `/sally/chksally/${userSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 방송  수정
function putSellerStatus(accessToken, Obj) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify(Obj.info))
  return axios({
    method: 'put',
    url: `/sally/broadcastsally/${Obj.broadcastSallySysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 판매자  사전등록 수정
function sellerPreRegAcc(accessToken, sellerSallySysId) {
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({ sellerSallys: [{sellerSallySysId: sellerSallySysId, regStatus: 1}] }))
  return axios({
    method: 'put',
    url: `/seller/sally/preregistration`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 판매회원 등록
function sellerJoin (accessToken, obj) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({ userSysId: userSysId, sallyName: obj.sallyName}))
  return axios({
    method: 'post',
    url: `/sally`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 일반회원 회원 조회
function sellerInfo (accessToken) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `/sally/chksally/${userSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

// 판매회원 수정
function sellerModify (accessToken, obj) {
  let userSysId = parseJwt(accessToken).authSysId
  let formdata = new FormData()
  formdata.append('jsonData', JSON.stringify({ userSysId: userSysId, sallyName: obj.sallyName}))
  return axios({
    method: 'put',
    url: `/sally/${obj.sallySysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    },
    data: formdata
  })
}

// 이름 중복 체크
function sellerNameChk (accessToken, sallyName) {
  return axios({
    method: 'get',
    url: `/sally/chkdupsallyname?sallyName=${sallyName}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}


// 판매회원 판매자 계약 해지 확인
function postSellerCancle (accessToken,sellerSallyHistSysId) {
    return axios({
      method: 'patch',
      url: `sally/preregistration/contract/${sellerSallyHistSysId}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${accessToken}`
      },
    })
  }

// 선물 메시지 전송 이력조회

function getPresentMsgHistory (accessToken) {
  return axios({
    method: 'get',
    url: `users/presentmsg/history`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}
// FAQ 상세조회

function getFaqDetail(siteFaqSysId) {
  return axios({
    method: 'get',
    url: `operations/faqs/${siteFaqSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}


// 세로형 라이브방송정보 리스트
function getVertiLiveList(startIndex, rowCount , displayAreaType) {
  return axios.get(`broadcasts/mainlists?startIndex=${startIndex}&rowCount=${rowCount}&displayAreaType=${displayAreaType}`)
  
}

// 방송 조회 정보 조회
function getVodViewCnt(broadcastSysId) {
  return axios({
    method: 'get',
    url: `broadcasts/infos/${broadcastSysId}/views`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 작성가능리뷰 카운트 
function getWriteableReviews(accessToken, getInfo) {
  let userSysId = parseJwt(accessToken).authSysId
  return axios({
    method: 'get',
    url: `users/${userSysId}/reviews/writeable/list?${getInfo}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    }
  })
}

//컨텐츠 목록조회
function getContentsList(startIndex,rowCount,contentsType) {
  return axios({
    method: 'get',
    url: `operations/contents/lists?startIndex=${startIndex}&rowCount=${rowCount}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 컨텐츠 상세정보 조회
function getContentsDetail(contentsSysId) {
  return axios({
    method: 'get',
    url: `operations/contents/${contentsSysId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 신규회원가입 쿠폰 조회
function getJoinCoupon () {
  return axios({
    method: 'get',
    url: `coupons/user/join`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export {
  demoLogin,
  requestOrder,
  getAccessToken,
  getRefressToken,
  getPublicKey,
  checkRSA,
  snsLogin,
  sendSms,
  checkJoinId,
  chkSmsAuth,
  userLogin,
  createtUser,
  getProductList,
  getProductLists,
  getCategoryList,
  getSaleProduct,
  getWeeklyProduct,
  getLiveProductList,
  getLiveProduct,
  getProduct,
  getProductDetail,
  getBrandList,
  getBroadCast,
  postOrders,
  payOrders,
  getUserInfo,
  getMemberAddrList,
  addMemberAddress,
  postCartItem,
  getCartItem,
  getAddingCosts,
  removeCartItem,
  putCartItem,
  modifyUserInfo,
  getMypageInfo,
  getPrdtReviewList,
  getPrdtQuestionList,
  writeQuestion,
  getNoticeList,
  changePw,
  removeCartList,
  getRecentViewList,
  setRecentViewList,
  postPrdtQuestion,
  getMyReviewList,
  setPicksList,
  delPicksList,
  getPicksList,
  delPicksLists,
  delRecentViewList,
  getPointInfo,
  searchProducts,
  searchBrands,
  searchBroadcasts,
  searchPassword,
  postReview,
  getAlertSetting,
  setAlertSetting,
  getProductReview,
  getFollowing,
  claimReview,
  patchUserPoint,
  nonMemberCartMerge,
  deleteMemberAddress,
  getBroadCastSchedules,
  setReservateBroadCast,
  getReservateBroadCast,
  removeReservateBroadCast,
  getFaqList,
  getKinxToken,
  checkJoinNick,
  snsAddInfo,
  getKinxMidBusToken,
  getPlanningList,
  getSellerOpenInfo,
  getUserOrders,
  setOrderCancle,
  getOrderInfo,
  getBrandInfo,
  getOrderPrdtInfo,
  getOrderedList,
  sendOrderRequest,
  getPayOrder,
  patchOrderResult,
  uploadImage,
  getOrderPrdtList,
  getDeliveryPrice,
  getMyQeustion,
  getBindingProducts,
  getNonUserOrderInfo,
  getOrdersList,
  getCancleExchangeList,
  setOrderExchange,
  getDeliveryLog,
  getBanks,
  reqSetRead,
  getAvailableCouponList,
  setOrderReturn,
  getDeliveryCompany,
  memberDrop,
  getCouponListByPrdt,
  getCoupon,
  getHasCouponList,
  setBuyFinish,
  getMainBannerPlan,
  getMainBannerPlanList,
  getMainBannerList,
  getSingleBannerPlan,
  chkEventInvalid,
  getEventPlan,
  getRewardWithdrawList,
  getAllPointList,
  getPointStatusList,
  getCancelOrders,
  getMyRewardList,
  groupChk,
  deleteOrder,
  sendLog,
  parseJwt,
  getReturnOrders,
  getDeliveryCompanyList,
  getLiveStatus,
  getLiveIntroInfo,
  broadcastReservation,
  broadcastReserveList,
  getReqDeliveryPay,
  postReqDeliveryPay,
  getExchangeOrders,
  patchExchangeDeliveryInfo,
  patchReturnDeliveryInfo,
  getBroadCastVodPlay,
  putReview,
  deleteReview,
  uploadMovie,
  getReqDeliveryPayInfo,
  alimTokChk,
  getShortLinkFromDynamicLink,
  getAvailCouponList,
  getUserNameforChk,
  getBroadCastPrdts,
  getLiveStreamDetail,
  putSellerStatus,
  userCheckSeller,
  sellerPreRegAcc,
  sellerJoin,
  sellerInfo,
  sellerModify,
  sellerNameChk,
  getSellerBroadCastList,
  getSellerContractList,
  postSellerPreRegist,
  postSellerCancle,
  getSellerSellHistory,
  increaseViewCnt,
  getPresentMsgHistory,
  getFaqDetail,
  getVertiLiveList,
  getWriteableReviews,
  getVodViewCnt,
  getContentsList,
  getContentsDetail,
  getJoinCoupon,
  chkRsaKey,
  translation
}
